<template>
<v-card
    class="pa-4 ma-0"
    elevation="4"
  >
    <h1>WISE Holders and Stakers</h1>
    <ul class="mb-5">
      <li>Holder: Having liquid WISE in the account</li>
      <li>Staker: Having staked WISE in the account</li>
    </ul>

    <div
      v-if="graphLoading"
      class="text-center"
    >
      <v-progress-circular
        indeterminate
        size="60"
        width="10"
        color="#FF14B0"
        class="my-5"
      ></v-progress-circular>
      <p>
        Loading Graph...
      </p>
    </div>

    <highcharts :options="chartOptions"></highcharts>

  </v-card>
</template>

<script>
import {
    Chart
  } from "highcharts-vue";
  import Highcharts from "highcharts";
  import HighchartsMore from "highcharts/highcharts-more";
  import dark from "highcharts/themes/dark-unica";

  HighchartsMore(Highcharts);
  dark(Highcharts);

  Highcharts.setOptions({
    colors: ['#3c44b1', '#33b1f6', '#29abb5', '#ffdc00aa']
  });

  import {
    mapState
  } from 'vuex';

  import {
    dayToDate
  } from '../utils/helpers.js';

  export default {
    name: 'Penalties',
    data() {
      return {
        data: [],
        graphLoading: false,
        chart: null,
        interval: 60,
        chartOptions: {
          chart: {
            // type: 'null',
            backgroundColor: null,
            zoomType: 'x',
            panning: true,
            panKey: 'shift',
            style: {
              fontFamily: "Roboto, sans-serif"
            }
          },
          title: {
            text: ''
          },
          subtitle: {
            text: 'Click and drag to zoom in. Hold shift to pan.'
          },
          credits: {
            text: 'wiseinfo.io',
            href: "https://wiseinfo.io",
            style: {
              fontSize: "12px",
              color: "#aaaaaa"
            },
            position: {
              x: -20,
              y: -20
            }
          },
          tooltip: {
            backgroundColor: '#555555',
            borderRadius: 10,
            borderWidth: 1,
            shared: true,
            split: true,
          },
          xAxis: [{
            type: 'linear',
            title: {
              text: 'Wise Day',
            },
            plotLines: []
          }],
          yAxis: [{
              // min: -300,
              // max: 7000,
              startOnTick: false,
              title: {
                text: 'Daily new Holders/Stakers',
              },
              plotLines: []
            },
            {
              opposite: true,
              title: {
                text: 'Cumulative total Holders/Stakers',
              },
              gridLineWidth: 0,
            },
          ],
          legend: {
            enabled: true
          },
          plotOptions: {
            column: {
              yAxis: 0,
              marker: {
                radius: 5
              },
              lineWidth: 5,
              states: {
                hover: {
                  lineWidth: 5
                }
              },
              // threshold: null
            },
            line: {
              // pointInterval: 86400000, // one day
              // pointStart: Date.UTC(2020, 10, 8),
              yAxis: 1,
              marker: {
                radius: 3
              },
              lineWidth: 1,
              states: {
                hover: {
                  lineWidth: 5
                }
              },
              // threshold: null
            },
          },
          series: [{
              type: 'column',
              name: 'Daily new Holders',
              visible: true,
              zIndex: 0,
              yAxis: 0,
              color: Highcharts.getOptions().colors[2],
              fillOpacity: 1,
              data: [],
              tooltip: {
                pointFormatter: function() {
                  return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y.toFixed(0) + ' WISE</b><br/>'
                }
              },
            },
            {
              type: 'line',
              name: 'Cumulative total Holders',
              visible: true,
              zIndex: 2,
              yAxis: 1,
              color: Highcharts.getOptions().colors[2],
              fillOpacity: 1,
              data: [],
              tooltip: {
                pointFormatter: function() {
                  return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y.toFixed(0) + ' WISE</b><br/>'
                }
              },
            },
            {
              type: 'column',
              name: 'Daily new Stakers',
              visible: true,
              zIndex: 0,
              yAxis: 0,
              color: Highcharts.getOptions().colors[1],
              fillOpacity: 1,
              data: [],
              tooltip: {
                pointFormatter: function() {
                  return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y.toFixed(0) + ' WISE</b><br/>'
                }
              },
            },
            {
              type: 'line',
              name: 'Cumulative total Stakers',
              visible: true,
              zIndex: 2,
              yAxis: 1,
              color: Highcharts.getOptions().colors[1],
              fillOpacity: 1,
              data: [],
              tooltip: {
                pointFormatter: function() {
                  return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.y.toFixed(0) + ' WISE</b><br/>'
                }
              },
            },
          ],
          responsive: {
            rules: [{
              condition: {
                maxWidth: 600
              },
              chartOptions: {
                yAxis: [{
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  }
                ]
              }
            }]
          }
        }
      }
    },
    components: {
      highcharts: Chart
    },
    created() {
      this.generateData();
    },
    computed: {
      ...mapState({
        dailyHolders: state => state.dailyHolders,
        dailyStakers: state => state.dailyStakers,
      }),
    },
    watch: {
      dailyHolders() {
        this.generateData();
      },
      dailyStakers() {
        this.generateData();
      }
    },
    methods: {

      receivedAllNeededData() {
        return (
          this.$store.state.dailyHolders.length > 0 &&
          this.$store.state.dailyStakers.length > 0
        );
      },

      generateData() {
        if (!this.receivedAllNeededData()) {
          return;
        }
        this.graphLoading = true;

        let dailyHolders = this.$store.state.dailyHolders;
        let dailyStakers = this.$store.state.dailyStakers;

        // Fix for different API results
        // let dailyStakersFixed = dailyStakers.map((day, index) => {
        //   let previousCumulativeStakers = index > 0 ? dailyStakers[index - 1].stakers : 0;
        //   if(day.stakers === undefined) {
        //     day.stakers = previousCumulativeStakers;
        //   }
        //   return {
        //     day: day.day,
        //     date: day.date,
        //     deltaStakers: day.stakers - previousCumulativeStakers,
        //     cumulativeStakers: day.stakers,
        //   }
        // })

        // this.chartOptions.series[0].data = allPenalties;

        // let startDay = 51;
        // let daysArray = Array.from({
        //   length: this.$store.state.currentWiseDay - startDay + 1
        // }, (_, i) => "Day " + (i + startDay));
        // this.chartOptions.xAxis[0].categories = daysArray
        this.chartOptions.xAxis[0].categories = dailyHolders.map(day => dayToDate(day.day) + " (Day " + day.day + ")");
        this.chartOptions.series[0].data = dailyHolders.map(day => day.deltaHolders);
        this.chartOptions.series[1].data = dailyHolders.map(day => day.cumulativeHolders);
        this.chartOptions.series[2].data = dailyStakers.map(day => day.deltaStakers);
        this.chartOptions.series[3].data = dailyStakers.map(day => day.cumulativeStakers);
        // this.chartOptions.series[2].data = dailyStakersFixed.map(day => day.deltaStakers);
        // this.chartOptions.series[3].data = dailyStakersFixed.map(day => day.cumulativeStakers);

        // this.chartOptions.series[0].data[0] = 0;
        // this.chartOptions.series[2].data[0] = 0;





        // let allPenalties = this.$store.state.allPenalties;
        // this.chartOptions.series[0].data = allPenalties;
        //
        // let startDay = 51;
        // let daysArray = Array.from({
        //   length: this.$store.state.currentWiseDay - startDay + 1
        // }, (_, i) => "Day " + (i + startDay));
        // this.chartOptions.xAxis[0].categories = daysArray
        //
        // let cumulativeSum = allPenalties.map((sum => value => sum += value)(0));
        //
        // this.chartOptions.series[1].data = cumulativeSum;

        this.graphLoading = false;
      },
    },
  }
</script>

<style >

</style>
